import {
  Box,
  Button,
  Checkbox,
  Chip,
  Container,
  Divider,
  FormControlLabel,
  Paper,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, useFormikContext, Field } from "formik";
import * as Yup from "yup";

import ProcedureSection from "./procedure";
import Faq from "./faq";
import DynamicFields from "./dynamicFields";
import ChooseMode from "./chooseMode";
import BasicInfoSection from "./basicInfoSection";
import GroupItemsSection from "./items";

import { IMAGE_URL } from "network";
import { uploadImage } from "services/imageUpload";

import {
  useGetSingleProductQuery,
  useAddProductMutation,
  useUpdateProductMutation,
} from "slices/beautyApp/productSlice";
import { deleteImage } from "services/imageUpload";
import Overview from "./overview";
import Points from "./points";
import TagSelection from "./tagSelection";
import Preview from "./preview";

// Helper component to sync formData with Formik
const FormikSync = ({ formData }) => {
  const { setValues } = useFormikContext();

  useEffect(() => {
    setValues(formData);
  }, [formData, setValues]);

  return null;
};

function AddItem() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const {
    data: initialData,
    isSuccess,
    isFetching,
  } = useGetSingleProductQuery(id, {
    skip: !isEdit,
  });

  const [addProduct] = useAddProductMutation();
  const [updateProduct] = useUpdateProductMutation();

  const [activeStep, setActiveStep] = useState(0);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewUrl2, setPreviewUrl2] = useState("");
  const [keywordInput, setKeywordInput] = useState("");

  const [formData, setFormData] = useState({
    type: "",
    category: "",
    subCategory: "",
    subCategoryType: "",
    duration: "",
    procedures: [],
    faq: [],
    servicePrice: 0,
    productPrice: 0,
    name: "",
    sub_title: "",
    off_percentage: 0,
    shortDescription: "Testing",
    image: "",
    backgroundImage: "",
    metaTitle: "",
    metaDescription: "",
    keywords: [],
    dynamicData: [],
    addOns: [],
    deletedFiles: [],
    isAvailable: true,
    top_selling: "inactive",
    overview: [],
    sub_points: [],
    skinTypes: [],
    concerns: [],
    tags: [],
    suitableFor: {
      gender: [],
      minAge: "",
      maxAge: "",
    },
  });

  useEffect(() => {
    if (isEdit && isSuccess && initialData?.data) {
      setFormData(initialData?.data);
      setPreviewUrl(IMAGE_URL + initialData?.data?.image);
      setPreviewUrl2(IMAGE_URL + initialData?.data?.backgroundImage);
    }
  }, [isEdit, isSuccess, initialData]);

  const stepsSingle = [
    "Basic",
    "Overview",
    "Points",
    "Media",
    "Procedures",
    "FAQs",
    "Fields",
    "Tags",
    "SEO",
  ];

  const stepsGroup = [
    "Basic",
    "Items",
    "Overview",
    "Points",
    "Media",
    "Procedures",
    "FAQs",
    "Fields",
    "Tags",
    "SEO",
  ];

  const steps = formData.type === "group" ? stepsGroup : stepsSingle;

  // Validation schemas for each step
  const validationSchemasSingle = {
    Basic: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      sub_title: Yup.string().required("Sub title is required"),
      type: Yup.string().required("Type is required"),
      category: Yup.string().required("Category is required"),
      subCategory: Yup.string().required("Sub-category is required"),
      subCategoryType: Yup.string().required("Sub-category-type is required"),
      duration: Yup.string().required("Duration is required"),
      servicePrice: Yup.number().required("Service price is required").min(0),
    }),

    Overview: Yup.object().shape({
      overview: Yup.array().min(1, "At least one overview item is required"),
    }),
    Points: Yup.object().shape({
      sub_points: Yup.array().min(1, "At least one point is required"),
    }),
    Media: Yup.object().shape({
      image: Yup.string().required("Main image is required"),
      backgroundImage: Yup.string().required("Background image is required"),
    }),
    Procedures: Yup.object().shape({
      procedures: Yup.array().min(1, "At least one procedure is required"),
    }),
    FAQs: Yup.object().shape({
      faq: Yup.array().min(1, "At least one FAQ is required"),
    }),
    Fields: Yup.object().shape({
      // dynamicData: Yup.array().min(1, "At least one field is required"),
    }),
    Tags: Yup.object().shape({
      // tags: Yup.array().min(1, "At least one tag is required"),
    }),
    SEO: Yup.object().shape({
      // metaTitle: Yup.string().required("Meta title is required"),
    }),
  };

  const validationSchemas = {
    Basic: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      sub_title: Yup.string().required("Sub title is required"),
      type: Yup.string().required("Type is required"),
      category: Yup.string().required("Category is required"),
      subCategory: Yup.string().required("Sub-category is required"),
      subCategoryType: Yup.string().required("Sub-category-type is required"),
      // duration: Yup.string().required("Duration is required"),
      // servicePrice: Yup.number().required("Service price is required").min(0),
    }),
    Items: Yup.object().shape({
      addOns: Yup.array().min(1, "At least one item is required"),
    }),

    Overview: Yup.object().shape({
      overview: Yup.array().min(1, "At least one overview item is required"),
    }),
    Points: Yup.object().shape({
      sub_points: Yup.array().min(1, "At least one point is required"),
    }),
    Media: Yup.object().shape({
      image: Yup.string().required("Main image is required"),
      backgroundImage: Yup.string().required("Background image is required"),
    }),
    Procedures: Yup.object().shape({
      procedures: Yup.array().min(1, "At least one procedure is required"),
    }),
    FAQs: Yup.object().shape({
      faq: Yup.array().min(1, "At least one FAQ is required"),
    }),
    Fields: Yup.object().shape({
      // dynamicData: Yup.array().min(1, "At least one field is required"),
    }),
    Tags: Yup.object().shape({
      // tags: Yup.array().min(1, "At least one tag is required"),
    }),
    SEO: Yup.object().shape({
      // metaTitle: Yup.string().required("Meta title is required"),
    }),
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  // const handleFieldChange = (field, value) => {
  //   setFormData((prev) => ({ ...prev, [field]: value }));

  //   if (field === "top_selling" && value === true) {
  //     setFormData((prev) => ({ ...prev, top_selling: "active" }));
  //   }

  //   if (field === "top_selling" && value === false) {
  //     setFormData((prev) => ({ ...prev, top_selling: "inactive" }));
  //   }

  // };

  const handleFieldChange = (field, value) => {
    setFormData((prev) => {
      const updatedData = { ...prev, [field]: value };

      if (field === "top_selling") {
        updatedData.top_selling = value ? "active" : "inactive";
      }

      return updatedData;
    });
  };

  const handleSectionChange = (field, value) => {
    if (field.includes(".")) {
      const [mainField, subField] = field.split(".");
      setFormData((prev) => ({
        ...prev,
        [mainField]: {
          ...prev[mainField],
          [subField]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const setDeletedFiles = (fileName) => {
    setFormData((prev) => ({
      ...prev,
      deletedFiles: [
        ...(Array.isArray(prev.deletedFiles) ? prev.deletedFiles : [],
        fileName),
      ],
    }));
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageName = await uploadImage(file);
      setPreviewUrl(IMAGE_URL + imageName);
      handleFieldChange("image", imageName);
    }
  };

  const handleImageUpload2 = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageName = await uploadImage(file);
      setPreviewUrl2(IMAGE_URL + imageName);
      handleFieldChange("backgroundImage", imageName);
    }
  };

  const addKeyword = () => {
    const kw = keywordInput.trim();
    if (kw && !formData.keywords.includes(kw)) {
      handleFieldChange("keywords", [...formData.keywords, kw]);
      setKeywordInput("");
    }
  };

  const removeKeyword = (kw) => {
    handleFieldChange(
      "keywords",
      formData.keywords.filter((k) => k !== kw)
    );
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (values.deletedFiles && values.deletedFiles.length > 0) {
        for (let index = 0; index < values.deletedFiles.length; index++) {
         await deleteImage(values.deletedFiles[index]);
        }
      }

      if (isEdit) {
        let response = await updateProduct({ id, body: values }).unwrap();

        if (response?.success === true) {
          setTimeout(() => {
            navigate("/beauty-app/products", { state: { refresh: true } });
          }, 1000);
        }
      } else {
        let response = await addProduct(values).unwrap();

        if (response?.success === true) {
          setTimeout(() => {
            navigate("/beauty-app/products", { state: { refresh: true } });
          }, 1000);
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const isStepCompleted = (stepIndex) => {
    const currentStep = steps[stepIndex];
    try {
      validationSchemas[currentStep].validateSync(formData, {
        abortEarly: false,
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleStepClick = (stepIndex) => {
    if (isStepCompleted(stepIndex)) {
      setActiveStep(stepIndex);
    } else if (stepIndex < activeStep) {
      setActiveStep(stepIndex);
    }
  };

  const handleNext = async (validateForm, setTouched, setFieldError, e) => {
    if (e) {
      e.preventDefault(); // Prevent default form submission
    }

    const currentStep = steps[activeStep];
    const schema =
      formData.type === "group"
        ? validationSchemas[currentStep]
        : validationSchemasSingle[currentStep];

    try {
      await schema.validate(formData, { abortEarly: false });
      if (activeStep < steps.length - 1) {
        setActiveStep((prev) => prev + 1);
      }
    } catch (errors) {
      // Error handling remains the same
      Object.keys(formData).forEach((field) => setFieldError(field, undefined));
      errors.inner.forEach((error) => {
        setFieldError(error.path, error.message);
      });
      const touched = {};
      errors.inner.forEach((error) => {
        touched[error.path] = true;
      });
      setTouched(touched);
    }
  };

  if (isEdit && isFetching) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
          <Typography variant="h6">Loading item data...</Typography>
        </Container>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="sm" sx={{ mt: 4, mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          {isEdit ? "Edit Item" : "Add Item"}
        </Typography>
        <Paper elevation={1} sx={{ p: 3 }}>
          {!isEdit && !formData.type ? (
            <ChooseMode
              value={formData.type}
              onChange={(val) => handleFieldChange("type", val)}
            />
          ) : (
            <Formik
              initialValues={formData}
              onSubmit={handleSubmit}
              enableReinitialize
              // validationSchema={validationSchemas[steps[activeStep]]}
              validationSchema={
                formData.type === "group"
                  ? validationSchemas[steps[activeStep]]
                  : validationSchemasSingle[steps[activeStep]]
              }
            >
              {({
                validateForm,
                setTouched,
                isSubmitting,
                errors,
                touched,
                setFieldError,
              }) => (
                <Form>
                  <FormikSync formData={formData} />

                  <div className="row">
                    <div
                      className={formData.name ? "col-md-8" : "col-md-12"}
                      style={{ position: "relative", paddingBottom: "44px" }}
                    >
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label, index) => (
                          <Step key={label}>
                            <StepLabel
                              onClick={() => handleStepClick(index)}
                              style={{
                                cursor:
                                  isStepCompleted(index) || index <= activeStep
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                            >
                              {label}
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>

                      {activeStep === steps.indexOf("Basic") && (
                        <BasicInfoSection
                          formData={formData}
                          handleFieldChange={handleFieldChange}
                          itemMode={formData.type}
                          errors={errors}
                          touched={touched}
                        />
                      )}

                      {steps.includes("Items") &&
                        activeStep === steps.indexOf("Items") && (
                          <GroupItemsSection
                            groupItems={formData.addOns}
                            onChange={(value) =>
                              handleSectionChange("addOns", value)
                            }
                            deletedFiles={formData.deletedFiles}
                            setDeletedFiles={(value) => setDeletedFiles(value)}
                            error={errors.addOns}
                            touched={touched.addOns}
                          />
                        )}

                      {steps.includes("Overview") &&
                        activeStep === steps.indexOf("Overview") && (
                          <Overview
                            overviewData={formData.overview}
                            onChange={(value) =>
                              handleSectionChange("overview", value)
                            }
                            deletedFiles={formData.deletedFiles}
                            setDeletedFiles={(value) => setDeletedFiles(value)}
                            error={errors.overview}
                            touched={touched.overview}
                          />
                        )}

                      {steps.includes("Points") &&
                        activeStep === steps.indexOf("Points") && (
                          <Points
                            subData={formData.sub_points}
                            onChange={(value) =>
                              handleSectionChange("sub_points", value)
                            }
                            error={errors.sub_points}
                            touched={touched.sub_points}
                          />
                        )}

                      {activeStep === steps.indexOf("Media") && (
                        <>
                          <Divider sx={{ my: 3 }} />
                          <Typography variant="h6">
                            Background Image*
                          </Typography>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload2}
                          />
                          {previewUrl2 && (
                            <Box mt={2}>
                              <img
                                crossorigin="anonymous"
                                src={previewUrl2}
                                alt="Background Preview"
                                style={{ width: 140, borderRadius: 8 }}
                              />
                            </Box>
                          )}
                          {errors.backgroundImage &&
                            touched.backgroundImage && (
                              <Typography color="error" variant="body2">
                                {errors.backgroundImage}
                              </Typography>
                            )}

                          <Divider sx={{ my: 3 }} />
                          <Typography variant="h6">Image*</Typography>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                          />
                          {previewUrl && (
                            <Box mt={2}>
                              <img
                                crossorigin="anonymous"
                                src={previewUrl}
                                alt="Main Preview"
                                style={{ width: 140, borderRadius: 8 }}
                              />
                            </Box>
                          )}
                          {errors.image && touched.image && (
                            <Typography color="error" variant="body2">
                              {errors.image}
                            </Typography>
                          )}
                        </>
                      )}

                      {activeStep === steps.indexOf("Procedures") && (
                        <ProcedureSection
                          procedures={formData.procedures}
                          onChange={(value) =>
                            handleSectionChange("procedures", value)
                          }
                          deletedFiles={formData.deletedFiles}
                          setDeletedFiles={(value) => setDeletedFiles(value)}
                          error={errors.procedures}
                          touched={touched.procedures}
                        />
                      )}

                      {activeStep === steps.indexOf("FAQs") && (
                        <Faq
                          faqs={formData.faq}
                          onChange={(value) =>
                            handleSectionChange("faq", value)
                          }
                          error={errors.faq}
                          touched={touched.faq}
                        />
                      )}

                      {activeStep === steps.indexOf("Fields") && (
                        <DynamicFields
                          dynamicData={formData.dynamicData}
                          onChange={(value) =>
                            handleSectionChange("dynamicData", value)
                          }
                          error={errors.dynamicData}
                          touched={touched.dynamicData}
                        />
                      )}

                      {activeStep === steps.indexOf("Tags") && (
                        <TagSelection
                          values={formData}
                          setFieldValue={(field, value) =>
                            handleSectionChange(field, value)
                          }
                          error={errors.tags}
                          touched={touched.tags}
                        />
                      )}

                      {activeStep === steps.indexOf("SEO") && (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.top_selling === "active"}
                                onChange={(e) =>
                                  handleFieldChange(
                                    "top_selling",
                                    e.target.checked
                                  )
                                }
                              />
                            }
                            label="Do you want to add this to trending listing?"
                          />

                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.isAvailable === true}
                                onChange={(e) =>
                                  handleFieldChange(
                                    "isAvailable",
                                    e.target.checked
                                  )
                                }
                              />
                            }
                            label="Service status (Active/Inactive)"
                          />

                          <Field name="metaTitle">
                            {({ field, meta }) => (
                              <TextField
                                {...field}
                                label="Meta Title"
                                fullWidth
                                margin="normal"
                                error={meta.touched && !!meta.error}
                                helperText={meta.touched && meta.error}
                              />
                            )}
                          </Field>

                          <TextField
                            label="Meta Description"
                            value={formData.metaDescription}
                            onChange={(e) =>
                              handleFieldChange(
                                "metaDescription",
                                e.target.value
                              )
                            }
                            fullWidth
                            margin="normal"
                          />

                          <Typography variant="h6" mt={2}>
                            Keywords
                          </Typography>
                          <Box display="flex" alignItems="center" gap={1}>
                            <TextField
                              label="Add Keyword"
                              value={keywordInput}
                              onChange={(e) => setKeywordInput(e.target.value)}
                              fullWidth
                            />
                            <Button onClick={addKeyword}>Add</Button>
                          </Box>

                          <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                            {formData.keywords.map((kw) => (
                              <Chip
                                key={kw}
                                label={kw}
                                onDelete={() => removeKeyword(kw)}
                              />
                            ))}
                          </Box>
                        </>
                      )}

                      {/* <Box
                        mt={3}
                        display="flex"
                        justifyContent="space-between"
                        sx={{ position: "absolute", width: "97%", bottom: "0" }}
                      >
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          variant="outlined"
                        >
                          Back
                        </Button>

                        {activeStep === steps.length - 1 ? (
                          <Button
                            variant="contained"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isEdit ? "Update Item" : "Add Item"}
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            onClick={() =>
                              handleNext(
                                validateForm,
                                setTouched,
                                setFieldError
                              )
                            }
                          >
                            Next
                          </Button>
                        )}
                      </Box> */}

                      <Box
                        mt={3}
                        display="flex"
                        justifyContent="space-between"
                        sx={{ position: "absolute", width: "97%", bottom: "0" }}
                      >
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          variant="outlined"
                        >
                          Back
                        </Button>

                        {activeStep === steps.length - 1 ? (
                          <Button
                            variant="contained"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isEdit ? "Update Item" : "Add Item"}
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            type="button"
                            onClick={(e) =>
                              handleNext(
                                validateForm,
                                setTouched,
                                setFieldError,
                                e
                              )
                            }
                          >
                            Next
                          </Button>
                        )}
                      </Box>
                    </div>

                    {formData.name && (
                      <div className="col-md-4">
                        <Preview formData={formData} />
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </Paper>
      </Container>
    </DashboardLayout>
  );
}

export default AddItem;
